import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=40257812&"
import script from "../../scripts/overlay/overlay.js?vue&type=script&lang=js&"
export * from "../../scripts/overlay/overlay.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports